<template>
  <div class="wangguan">
    <div class="top">
      <div class="left">网关列表</div>
      <el-button type="primary" @click="setWangguan(false)">新增网关</el-button>
    </div>
    <div class="table-box">
      <el-table :data="tableData" style="width: 100%">
        <!-- <el-table-column prop="id" label="编号"> </el-table-column> -->
        <el-table-column label="序号" type="index" align="center" width="50px">
        </el-table-column>
        <el-table-column prop="roomName" label="配电室"> </el-table-column>
        <el-table-column prop="productName" label="网关名"> </el-table-column>
        <el-table-column prop="productKey" label="key"> </el-table-column>
        <el-table-column prop="edit" label="操作" width="200">
          <template slot-scope="scope">
            <div class="btn-out-box">
              <div
                class="btn-box color1"
                :class="scope.row.isOpen ? 'active' : ''"
                @click="setWangguan(scope.row)"
              >
                <i class="iconfont icon-bianji1"></i>
              </div>
              <!-- <div
                class="btn-box color2"
                :class="scope.row.isOpen ? 'active' : ''"
                @click="deleteThis(scope.row)"
              >
                <i class="iconfont icon-close"></i>
              </div> -->
              <div
                class="btn-box color3"
                :class="scope.row.isOpen ? 'active' : ''"
                @click="setShebei(scope.row)"
              >
                <i class="iconfont icon-lianjie"></i>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        class="m-t-20"
        background
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="total"
        @current-change="paginationHandle"
      >
      </el-pagination> -->
      <div class="pagination-info">
        <div class="left">
          第 {{ currentPage }} 页（共{{ Math.ceil(total / size) }}页），显示{{
            (currentPage - 1) * size + 1
          }}至{{
            currentPage * size >= total ? total : currentPage * size
          }}项结果，共{{ total }}项
        </div>
        <div class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="paginationHandle"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="新增/编辑网关设备" :visible.sync="dialogFormVisible">
      <el-form :label-position="'right'" label-width="120px" :model="form">
        <el-form-item label="网关名：">
          <el-input v-model.trim="form.productName"></el-input>
        </el-form-item>
        <el-form-item label="key：">
          <el-input v-model.trim="form.productKey"></el-input>
        </el-form-item>
        <el-form-item label="线上or线下">
          <el-radio-group v-model="form.productType">
            <el-radio label="1">线上</el-radio>
            <el-radio label="2">线下</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="配电室：">
          <el-select v-model="form.equipmentRoomId" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrupdata">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      title="绑定设备"
      :visible.sync="drawer"
      :direction="'rtl'"
      size="25%"
    >
      <div class="tree-box">
        <el-tree
          :data="data"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="tree"
          :indent="0"
        >
        </el-tree>
        <div slot="footer" class="footer">
          <el-button @click="drawer = false">取 消</el-button>
          <el-button type="primary" @click="bindEquipment">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  Message
} from 'element-ui';
export default {
  data() {
    return {
      id: "",
      drawer: false,
      idAdd: -1,
      productKey: "",
      tableData: [],
      dialogFormVisible: false,
      form: {
        productName: "",
        productKey: "",
        productType: "",
        equipmentRoomId: "",
        dataType: 1,
      },
      projectId: "",
      options: [],
      data: [],
      currentPage: 1,
      size: 10,
      total: 0,
    };
  },
  props: {
    rightIndex: {
      type: String,
      default: "",
    },
  },
  watch: {
    rightIndex(v) {
      // alert(v);
      this.searchGatewayList();
      this.searchEquipmentRoomList();
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.searchGatewayList();
    this.searchEquipmentRoomList();
  },
  methods: {
    // 分页
    paginationHandle(e) {
      this.currentPage = e;
      this.searchGatewayList();
    },
    handleSizeChange(e) {
      this.currentPage = 1;
      this.size = e;
      this.searchGatewayList();
    },
    searchEquipmentRoomList() {
      this.$http
        .post(
          "bma-distribution-service/equipmentRoom/searchEquipmentRoomList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            // console.log(res.data);
            let arr = [];
            res.data.forEach((item) => {
              let obj = {
                value: item.id,
                label: item.roomName,
              };
              arr.push(obj);
            });
            this.options = arr;
            console.log(this.options);
          }
        });
    },
    setWangguan(e) {
      // false 新增
      if (e) {
        // 编辑
        if (!e.isOpen) return;
        this.isAdd = e.id;
        this.form = e;
        this.form.productType = e.productType + "";
        this.form.productType = e.productType + "";
        this.dialogFormVisible = true;
      } else {
        // 新增
        this.isAdd = -1;
        this.form = {
          productName: "",
          productKey: "",
          productType: "",
          equipmentRoomId: "",
          dataType: 1,
        };
        this.dialogFormVisible = true;
      }
    },
    setShebei(e) {
      if (!e.isOpen) return;
      this.productKey = e.productKey;
      this.searchRoomGatewayEquipmentTree(e);
      this.drawer = true;
    },
    // 获取网关
    searchGatewayList() {
      this.$http
        .post("bma-distribution-service/equipmentGateway/searchGatewayList", {
          projectId: this.id,
          currentPage: this.currentPage,
          size: this.size,
        })
        .then((res) => {
          if (res.code == 200) {
            console.log("网关");
            if (res.data) {
              res.data.records.forEach((item) => {
                if (item.status == 1) {
                  item.isOpen = true;
                } else {
                  item.isOpen = false;
                }
              });
              this.total = res.data.total;
              this.tableData = res.data.records;
            } else {
              this.tableData = [];
            }
          }
        });
    },
    // 新增方法
    addEquipmentGateway() {
      this.dialogFormVisible = false;
      console.log(this.form);
      this.$http
        .post(
          "bma-distribution-service/equipmentGateway/addEquipmentGateway",
          this.form
        )
        .then((res) => {
          if (res.code == 200) {
            Message.success("添加成功");
            this.searchGatewayList();
          }
        });
    },
    // 更新
    updateEquipmentGateway() {
      this.dialogFormVisible = false;
      this.form.id = this.isAdd;
      this.form.dataType = 1;
      this.$http
        .post(
          "bma-distribution-service/equipmentGateway/updateEquipmentGateway",
          this.form
        )
        .then((res) => {
          if (res.code == 200) {
            Message.success("更新成功");
          }
          this.searchGatewayList();
        });
    },
    deleteThis(e) {
      console.log(e);
      // deleteEquipmentGateway
      this.$http
        .post(
          "bma-distribution-service/equipmentGateway/deleteEquipmentGateway",
          {
            productKey: e.productKey,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            Message.success("删除成功");
            this.currentPage = 1;
            this.searchGatewayList();
          }
        });
    },
    addOrupdata(e) {
      if (this.isAdd == -1) {
        this.addEquipmentGateway();
      } else {
        this.updateEquipmentGateway();
      }
    },
    // 树形结构
    searchRoomGatewayEquipmentTree(e) {
      console.log(e);
      this.$http
        .post(
          "bma-distribution-service/equipment/searchRoomGatewayEquipmentTree",
          {
            roomId: e.equipmentRoomId,
            productKey: e.productKey,
          }
        )
        .then((res) => {
          console.log(res);
          let checkedList = [];
          let arr2 = [];
          res.data.forEach((item2) => {
            let arr3 = [];
            if (item2.cabinetTreeList) {
              item2.cabinetTreeList.forEach((item3) => {
                let arr4 = [];
                if (item3.equipmentTreeList) {
                  item3.equipmentTreeList.forEach((item4) => {
                    let obj4 = {
                      id: item4.id,
                      label: item4.localeNumber,
                    };
                    if (item4.isThisGateway == 1) {
                      checkedList.push(obj4);
                    }
                    if (item4.isThisGateway == 2) {
                      obj4.disabled = true;
                    }
                    arr4.push(obj4);
                  });
                }
                let count2 = item3.sonCount || 0;
                let obj3 = {
                  id: item3.id,
                  label: item3.cabinetNum + "（" + count2 + "）",
                  children: arr4,
                };
                arr3.push(obj3);
              });
            }
            if (item2.equipmentTreeList) {
              item2.equipmentTreeList.forEach((item3) => {
                let obj3 = {
                  id: item3.id,
                  label: item3.localeNumber,
                };
                if (item3.isThisGateway == 1) {
                  checkedList.push(obj3);
                }
                if (item3.isThisGateway == 2) {
                  obj3.disabled = true;
                }
                arr3.push(obj3);
              });
            }
            let count = item2.sonCount || 0;
            let obj2 = {
              id: item2.id,
              label: item2.typeName + "（" + count + "）",
              children: arr3,
            };
            arr2.push(obj2);
          });
          this.data = arr2;
          setTimeout(() => {
            this.$refs.tree.setCheckedNodes(checkedList);
          }, 0);
        });
    },
    bindEquipment() {
      let checkedNodes = this.$refs.tree.getCheckedNodes();
      let ids = [];
      checkedNodes.forEach((item) => {
        if (!item.children) {
          ids.push(item.id);
        }
      });
      console.log(ids);
      this.$http
        .post(
          "bma-distribution-service/equipmentGateway/bindGatewayEquipment",
          {
            productKey: this.productKey,
            equipmentIds: ids.toString(),
          }
        )
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            Message.success("绑定成功");
            this.drawer = false;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.wangguan {
  background: #fff;
  padding: 10px;
  border-radius: 7px;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 28px;
    .left {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .table-box {
    text-align: center;
    .el-table {
      background: rgba(0, 0, 0, 0);
      /deep/th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      /deep/th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      /deep/tr {
        td {
          font-size: 14px;
          color: #152139;
          text-align: center;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.color1.active {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
        &.color2.active {
          background: rgba(255, 41, 41, 0.1);
          .iconfont {
            color: rgba(255, 41, 41, 1);
          }
        }
        &.color3.active {
          background: rgba(253, 151, 101, 0.1);
          .iconfont {
            color: rgba(253, 151, 101, 1);
          }
        }
      }
    }
  }
  /deep/.el-dialog {
    width: 35%;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-input {
      // width: 323px;
    }
  }
  /deep/.el-drawer__body {
    overflow: scroll;
  }
  .tree-box {
    border-top: 1px solid #e7e7e7;
    padding: 20px;
    .footer {
      position: fixed;
      bottom: 20px;
      right: 10px;
    }
    /deep/.el-tree {
      .el-tree-node:before {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
      }
      .el-tree-node:after {
        content: "";
        left: -4px;
        position: absolute;
        right: auto;
        border-width: 1px;
      }
      .el-tree-node:before {
        border-left: 1px dashed rgba(195, 195, 195, 1);
        bottom: 0px;
        height: 100%;
        top: -26px;
        width: 1px;
      }
      .el-tree-node:after {
        border-top: 1px dashed rgba(195, 195, 195, 1);
        height: 20px;
        top: 12px;
        width: 24px;
      }
      > .el-tree-node:after {
        border-top: none;
      }
      .el-tree-node {
        position: relative;
        padding-left: 16px;
      } //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
      .el-tree-node__expand-icon.is-leaf {
        display: none;
      }
      .el-tree-node__children {
        padding-left: 16px;
      }
      .el-tree-node :last-child:before {
        height: 38px;
      }
      > .el-tree-node:before {
        border-left: none;
      }
      > .el-tree-node:after {
        border-top: none;
      }
    }
  }
  /deep/.el-drawer {
    outline: none;
    .el-drawer__header {
      span {
        outline: none;
        font-weight: 600;
        color: rgba(14, 34, 61, 1);
        font-size: 20px;
      }
    }
  }
  .pagination-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .left {
      font-size: 12px;
      color: rgba(137, 146, 159, 1);
    }
  }
}
</style>
